export class AccionistaEconomica {

    constructor({ tipoFrmEmpresa = null } = {}) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;
        this.model = {
            ingreso_mensual_rel_dep: {
                value: 0,
                header: 'Ingreso Mensual en Relación de dependencia USD:',
                required: 'Ingreso Mensual en Relación de dependencia es requerido'
            },
            otros_ingresos: {
                value: 0,
                header: 'Otros Ingresos USD:',
                required: 'Otros Ingresos es requerido'
            },
            fuente_ingresos: {
                value: '',
                header: 'Especifique la fuente de los otros ingresos:',
                required: false,
                maxLength: 'Máximo 1000 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 1000,
                min: 4,
            },
            otra_actividad_economica: {
                value: null,
                header: 'Otra Actividad Económica:',
                required: false,
                table: true,
                tablePorTipo: {
                    FRM_TOYOTA: false,
                    FRM_DIFARE: false,
                }
            },
            in_mensual_rel_dep_cony: {
                value: 0,
                header: 'Ingreso Mensual en Relación de dependencia (Cónyuge/Conviviente) USD:',
                required: 'Ingreso Mensual en Relación de dependencia es requerido'
            },
            otros_ingresos_cony: {
                value: 0,
                header: 'Otros Ingresos (Cónyuge/Conviviente) USD:',
                required: 'Otros Ingresos es requerido'
            },
            fuente_ingresos_cony: {
                value: '',
                header: 'Especifique la fuente de los otros ingresos del Cónyuge/Conviviente:',
                required: false,
                maxLength: 'Máximo 1000 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 1000,
                min: 4,
            },
            otra_actividad_economica_cony: {
                value: null,
                header: 'Otras actividades económicas (Cónyuge/Conviviente):',
                required: false,
                table: true,
                tablePorTipo: {
                    FRM_TOYOTA: false,
                    FRM_DIFARE: false,
                }
            },
            gasto_mensual: {
                value: 0,
                header: 'Gastos Individuales (en el caso de ser soltero) / Familiares Mensuales USD:',
                required: 'Gastos Individuales es requerido'
            },
            ACTV_INMUEBLES: {
                value: 0,
                header: 'Bienes inmuebles (casa, departamento, etc.) USD:',
                required: 'Bienes inmuebles es requerido'
            },
            ACTV_MUEBLES: {
                value: 0,
                header: 'Bienes muebles (vehículo, enceres, etc.) USD:',
                required: 'Bienes muebles es requerido'
            },
            ACTV_EFECTIVO: {
                value: 0,
                header: 'Dinero (en efectivo, en bancos u otros) USD:',
                required: 'Valor es requerido'
            },
            ACTV_INVERSIONES: {
                value: 0,
                header: 'Inversiones USD:',
                required: 'Inversiones es requerido'
            },
            ACTV_CREDITOS: {
                value: 0,
                header: 'Créditos por cobrar USD:',
                required: 'Créditos por cobrar es requerido'
            },
            ACTV_OTROS: {
                value: 0,
                header: 'Otros activos USD:',
                required: 'Otros activos es requerido'
            },
            total_activos: {
                value: 0,
                header: 'Total Activos USD:',
                required: 'Total Activos es requerido'
            },
            PASV_BANCARIOS: {
                value: 0,
                header: 'Préstamos bancarios (consumo)USD:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Préstamos bancarios (consumo):',
                    FRM_DIFARE: 'Préstamos bancarios (consumo):',
                },
                required: 'Préstamos bancarios es requerido'
            },
            PASV_HIPOTECARIOS: {
                value: 0,
                header: 'Préstamos hipotecarios USD:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Préstamos hipotecarios:',
                    FRM_DIFARE: 'Préstamos hipotecarios:',
                },
                required: 'Préstamos hipotecarios es requerido'
            },
            PASV_QUIROGRAFARIO: {
                value: 0,
                header: 'Préstamo quirografario USD:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Préstamo quirografario:',
                    FRM_DIFARE: 'Préstamo quirografario:',
                },
                required: 'Préstamo quirografario es requerido'
            },
            PASV_CREDITO: {
                value: 0,
                header: 'Tarjeta de crédito USD:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Tarjeta de crédito:',
                    FRM_DIFARE: 'Tarjeta de crédito:',
                },
                required: 'Tarjeta de crédito es requerido'
            },
            PASV_OTRAS_CTAS: {
                value: 0,
                header: 'Otras Cuentas/Documentos por pagar USD:',
                required: 'Otras Cuentas / Documentos por pagar es requerido'
            },
            PASV_OTROS_PASV: {
                value: 0,
                header: 'Otros pasivos USD:',
                required: 'Otros pasivos es requerido'
            },
            total_pasivos: {
                value: 0,
                header: 'Pasivos USD:',
                required: 'Pasivos es requerido'
            },
            total_patrimonio: {
                value: 0,
                header: 'Patrimonio (Activos - Pasivos) USD:',
                required: 'Patriminio es requerido'
            },
        }
        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
            if (campo.tablePorTipo && tipoFrmEmpresa && campo.tablePorTipo[tipoFrmEmpresa] !== undefined) {
                campo.table = campo.tablePorTipo[tipoFrmEmpresa];
            }
        });
    }
    optionLabel = 'nombre';
}
